import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=b5e7baa8&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5e7baa8')) {
      api.createRecord('b5e7baa8', component.options)
    } else {
      api.reload('b5e7baa8', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=b5e7baa8&", function () {
      api.rerender('b5e7baa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cCBq56XRy6oY/JS/pricehelp.vue"
export default component.exports